// Generated by `pnpm generate:modules` from modules/catalogue.json. Do not edit.

import { warikeSiteBrowserModule } from "@amtana/warike-site-browser/declaration";

export const browserModules = [warikeSiteBrowserModule] as const;
